import { Injectable } from '@angular/core'
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  constructor() {}

  log(label, message) {
    if (environment.flags.logging) {
      console.log(label, message)
    }
  }
}
